import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { ModalData } from '@datachain/ui-sdk/components/app-modal';
import { Map } from 'immutable';
import { firstValueFrom, Observable, ReplaySubject } from 'rxjs';

import { DcIcons } from '../../app-dc.icons';

type ElementDetails = {
	label: string;
	uuid: string;
	type: 'column' | 'columnTemplate' | 'filterTemplate';
};

export type ColumnUsageReport = ElementDetails & {
	colTemplates: Array<ElementDetails>;
	filterTemplates: Array<ElementDetails>;
};

export type SubscriptionColumnUpdateReport = {
	code: number;
	msg: string;
	elements: Array<ColumnUsageReport>;
};

type ReportPerColumn = ColumnUsageReport & { isOpen: boolean };

@Component({
	selector: 'app-update-report',
	templateUrl: './app-update-report.component.html',
	styleUrls: ['./app-update-report.component.scss'],
})
export class AppUpdateReportComponent<
	T extends SubscriptionColumnUpdateReport
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		message: string;
		report: Map<string, ReportPerColumn>;
	}>;

	private readonly mappingSubject = new ReplaySubject<
		Map<string, ReportPerColumn>
	>(1);
	public constructor(
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'subscription-columns-update-popup-report';

		const initialValue = Map<string, ReportPerColumn>(
			this.modalData.elements.map((el) => [
				el.uuid,
				{
					...el,
					isOpen: false,
				},
			])
		);

		this.mappingSubject.next(initialValue);

		this.vo$ = combineAll({
			message: this.modalData.msg,
			report: this.mappingSubject,
		});
	}

	public async toggleReportFor(colUuid: string): Promise<void> {
		const current = await firstValueFrom(this.mappingSubject);
		const val = current.get(colUuid);
		if (!val) {
			return;
		}
		val.isOpen = !val.isOpen;
		const updated = current.set(colUuid, val);
		this.mappingSubject.next(updated);
	}
}
